import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { getOptionList } from '@/api/dashboard/project.js';

export default {
  name: 'AccountMtgSelector',

  componentName: 'AccountMtgSelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      remoteLoading: false,
      options: []
    };
  },


  computed: {
    innerConfig: function innerConfig() {
      var params = _extends({
        filterable: true,
        placeholder: '请选择mtg主账号',
        remote: true,
        options: this.options
      }, this.config.params);
      return _extends({}, this.config, {
        params: params
      });
    }
  },

  methods: {
    remoteBase: function remoteBase(query) {
      var _this = this;

      this.remoteLoading = true;
      getOptionList({
        option_type: 'account',
        keyword: query
      }).then(function (res) {
        _this.remoteLoading = false;
        _this.options = (_.get(res, 'data.data.options') || []).map(function (item) {
          var params = _this.innerConfig.params || {};
          return _extends({}, item, {
            value: item[params.valueKey || 'value'],
            label: item[params.labelKey || 'name']
          });
        });
      }).catch(function () {
        _this.options = [];
        _this.remoteLoading = false;
      });
    },
    setOptions: function setOptions(options) {
      if (_.isArray(options)) {
        this.options = options;
      } else if (_.isObject(options)) {
        if (_.findIndex(this.options, function (item) {
          return item.value === options.value;
        }) === -1) {
          this.options.push(options);
        }
      }
    }
  },

  mounted: function mounted() {
    if (!this.options.length) {
      this.remoteBase('');
    }
  }
};